/**
 * Why there are so many callbacks exists?
 * Because they don't want to standardize it.
 */

/**
 * 20x callback with json format from moka-service-auth a.k.a /account api
 * @param response
 * @return {Promise.<T>}
 */
export function serviceAccountSuccessCallback (response) {
  return Promise.resolve(response)
}

export function serviceLibrarySuccessCallback (response) {
  return Promise.resolve(response)
}

export function serviceReportingSuccessCallback (response) {
  return Promise.resolve(response)
}

/**
 * 4xx/5xx callback with json format from moka-service-auth a.k.a /account api
 * @param error
 * @return {Promise.<T>}
 */
export function serviceAccountErrorCallback (error) {
  if (error.response && error.response.data) {
    const data = error.response.data
    // default error message
    let message = error.message

    if (data.error && data.error.user_message) { // error from Springboot
      message = data.error.user_message
    } else if (data.message) { // error from api gateway
      message = data.message
    } else if (typeof data.error === 'string') { // unhandled server error from springboot
      message = data.error
    }
    return Promise.reject({
      message,
      data: data
    })
  } else {
    return Promise.reject({
      message: error.message
    })
  }
}

export function serviceLibraryErrorCallback (error) {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function serviceReportingErrorCallback (error) {
  const {response} = error
  return Promise.resolve(response)
}



// WEBPACK FOOTER //
// ./app/api/callbacks.js